import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";
import FlowstationPerformanceStore from "../../store/FlowstationPerformanceStore";
import { createContext } from "react";
import { toJS } from "mobx";
import { Skeleton } from "antd";
import $ from "jquery";
const _ = require("underscore");
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);

export const FlowstationOilProductionDonut = ({ showLabel, showLegend }) => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );

  return (
    <Observer>
      {() =>
        flowstationPerformanceStore.isLoading ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                renderTo: "container",
                type: "pie",
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                text:
                  "Total Oil<br/><span style='color:red'>" +
                  Number(
                    Number(
                      _.reduce(
                        [
                          ...flowstationPerformanceStore.flowstationProductions.values(),
                        ].map((x) => toJS(x.oil_Volume)),
                        function (memo, num) {
                          return memo + num;
                        },
                        0
                      )
                    ).toFixed(2)
                  ).toLocaleString() +
                  "bopd</span><br/> <br/>Active Oil Strings<br/>" +
                  "<span style='color:green'>" +
                  flowstationPerformanceStore.activeOilStrings +
                  "</span>",
                align: "center",
                verticalAlign: "middle",
                style: {
                  fontWeight: "bold",
                  fontSize: "14px",
                },
                y: -20, // Positioning the title
              },
              events: {
                load: function (event) {
                  var total = 0; // get total of data
                  for (
                    var i = 0, len = this.series[0].yData.length;
                    i < len;
                    i++
                  ) {
                    total += this.series[0].this.y[i];
                  }
                  this.renderer
                    .text("Total: " + total, this.plotLeft, this.plotTop - 20)
                    .attr({ zIndex: 5 })
                    .add();
                },
              },
              tooltip: {
                formatter: function () {
                  return (
                    "<b>" +
                    this.point.name +
                    "</b>:<br/>" +
                    Math.round(this.y).toLocaleString() +
                    "bopd" +
                    "</b>:<br/>" +
                    Number(this.percentage).toFixed(2) +
                    "%"
                  );
                },
              },
              legend: {
                enabled: showLegend,
                floating: false,
                borderWidth: 0,
                align: "center",
                layout: "horizontal",
                verticalAlign: "bottom",
                labelFormatter: function () {
                  return (
                    '<span style="font-family:Verdana, Geneva, sans-serif; font-weight: normal; font-size:10px">' +
                    this.name +
                    " </span>"
                  );
                },
              },
              yAxis: {
                title: {
                  text: "",
                },
              },
              plotOptions: {
                pie: {
                  shadow: false,
                },
              },
              series: [
                {
                  name: "Oil",
                  data: [
                    ...flowstationPerformanceStore.flowstationProductions.values(),
                  ].map((x) => {
                    return {
                      name: toJS(x.flowstation),
                      y: toJS(x.oil_Volume),
                    };
                  }),

                  size: "100%",
                  innerSize: "65%",
                  showInLegend: showLegend,
                  dataLabels: {
                    enabled: showLabel,
                    formatter: function () {
                      if (showLegend) {
                        return (
                          '<span style="font-family:Verdana, Geneva, sans-serif; font-weight: normal; font-size:10px">' +
                          Math.round(this.point.y).toLocaleString() +
                          ": <br/>" +
                          Number(this.percentage).toFixed(2) +
                          "%" +
                          " </span>"
                        );
                      } else {
                        return (
                          '<span style="font-family:Verdana, Geneva, sans-serif; font-weight: normal; font-size:10px">' +
                          this.key +
                          ": <br/>" +
                          Math.round(this.point.y).toLocaleString() +
                          ": <br/>" +
                          Number(this.percentage).toFixed(2) +
                          "%" +
                          " </span>"
                        );
                      }
                    },
                  },
                },
              ],

              function(chart) {
                // on complete
                var textX = chart.plotLeft + chart.plotWidth * 0.5;
                var textY = chart.plotTop + chart.plotHeight * 0.5;

                var span =
                  '<span id="pieChartInfoText" style="position:absolute; text-align:center;">';
                span += '<span style="font-size: 32px">Upper</span><br>';
                span += '<span style="font-size: 16px">Lower</span>';
                span += "</span>";

                $("#addText").append(span);
                span = $("#pieChartInfoText");
                span.css("left", textX + span.width() * -0.5);
                span.css("top", textY + span.height() * -0.5);
              },
            }}
          />
        )
      }
    </Observer>
  );
};

